/**
 * StoreLogger middleware
 * 
 * This provides a way to track all changes made to stores and from what dispatches.
 * These logs can be viewed inside the console of your browsers debugger.
 * 
 * SETUP
 * 
 * Create a config file that is loaded somewhere in your app.
 * Import the middleware config functions, from both the StoreLogger and CreateStore
 * @example 
 * import StoreLoggerMiddleware from '@@/middleware/stores/StoreLogger';
 * 
 * Apply the middleware to CreateStore ApplyMiddlware function
 * @example ApplyMiddleware([StoreLoggerMiddleware])
 * 
 * Make sure to include the config file somewhere in your application hiearchy
 * /src/index.js or src/app.js is a good place.
 * @example import "@@/config/StoresConfig"
 */

const bodyCSS = "color:gray;font-weight:lighter";
const prevCSS = "color:gray;font-weight:bold";
const storeCSS = "font-weight:bold";
const nextCSS = "color:#6bc679;font-weight:bold";

// Use performance API if it's available in order to get better precision
const timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;
const StoreLoggerMiddleware = name => events => action => state => next => {
  //Only log outputs for 'development' environment
  if (process.env.NODE_ENV !== "development") {
    return next(name, events, action, state);
  }
  const started = timer.now();
  let nextState = next(name, events, action, state);
  if (!action.options.silent) {
    const duration = timer.now() - started;
    console.groupCollapsed(`%clistener %c${name} %c(in ${duration.toFixed(2)} ms)`, bodyCSS, storeCSS, bodyCSS);
  }
  if (!nextState) {
    nextState = "State Undefined - No update or change event made";
  }
  if (!action.options.silent) {
    console.log(`%cprev state`, prevCSS, state);
    console.log(`%cnext state`, nextCSS, nextState);
    console.groupEnd();
  }
  return nextState;
};
export default StoreLoggerMiddleware;